import React, {useEffect, useState} from "react";
import {styled} from "@mui/material/styles";
import Tooltip, {tooltipClasses} from "@mui/material/Tooltip";
import {Button} from "@material-ui/core";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Slide from "@mui/material/Slide";
import {ErrorMessage, Field, Form, Formik} from "formik";
import {basicSchema} from "../schemas/Schemas";
import {motion} from "framer-motion";
import LoadingButton from "@mui/lab/LoadingButton";
import TextField from "@mui/material/TextField";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {DesktopDatePicker} from "@mui/x-date-pickers/DesktopDatePicker";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import RichTextEditor from "../RichTextEditor/RichTextEditor";
import EditorState from "draft-js/lib/EditorState";
import {convertToRaw} from "draft-js";
import draftToHtml from "draftjs-to-html";
import CryptoJS from "crypto-js";
import {dateSchema} from "../schemas/Schemas";
import {
    AccountBalanceWallet,
    Apartment,
    Assignment,
    Payment,
    Warning,
    Send
} from '@mui/icons-material';
import {ApiDetails, KEY} from "../../dummyData";

// Transition component for dialogs
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

// Styled tooltip component
const HtmlTooltip = styled(({className, ...props}) => (
    <Tooltip {...props} classes={{popper: className}}/>
))(({theme}) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: "#ffffff",
        color: "rgba(0, 0, 0, 0.87)",
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(12),
        border: "1px solid #dadde9",
        boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
        padding: "12px 16px",
        borderRadius: "8px"
    },
}));

export default function FeaturedInfoModern(props) {
    // Decrypt tenant details from localStorage
    let details = CryptoJS.AES.decrypt(
        localStorage.getItem("tenant_details"),
        KEY
    );

    let originalText = details.toString(CryptoJS.enc.Utf8);

    // State variables
    const [detailsSet, setDetailsSet] = useState(false);
    const [backDrop, setBackDrop] = useState(
        <Backdrop
            sx={{color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1}}
            open={true}
        >
            <CircularProgress color="inherit"/>
        </Backdrop>
    );

    const [tenantDetails, setTenantDetails] = useState(
        new Map(
            Object.entries({
                tenant_id: "",
                first_name: "",
                last_name: "",
                national_id: "",
                email_address: "",
                phone_number: "",
                house_number: "",
                rent: "",
                bill: "",
                arrears: "",
                account_balance: "",
                amount: "",
                state: "",
                temp_account_balance: "",
                minimum_days_to_vacate: "",
                date_created: "",
                Wallet: "",
                status: "",
                property_name: "",
            })
        )
    );

    const [warningModal, setWarningModal] = useState(false);
    const [paymentModal, setPaymentModal] = useState(false);
    const [vacatingNoticeModal, setVacatingNoticeModal] = useState(false);
    const [editorState, setEditorState] = useState(() => EditorState.createEmpty());
    const [dateToday] = useState(new Date());
    const [dateToVacate, setDateToVacate] = useState(new Date());
    const [tenantLoading, setTenantLoading] = useState(false);
    const [valuesAfterWarning, setValuesAfterWarning] = useState({});
    const [vacatingWarningModalNotice, setVacatingWarningModalNotice] = useState("");

    // Initial values for forms
    const initialPaymentValues = {
        amount: tenantDetails.get("status") === "COMPLETED" ? 0 : tenantDetails.get("Wallet"),
        phone_number: tenantDetails.get("phone_number"),
    };

    const initialValues2 = {
        first_name: tenantDetails.get("first_name"),
        last_name: tenantDetails.get("last_name"),
        phone_number: tenantDetails.get("phone_number"),
        national_id: tenantDetails.get("national_id"),
        unit: tenantDetails.get("house_number"),
        property_name: tenantDetails.get("property_name"),
        landlord_id: tenantDetails.get("landlord_id"),
        tenant_id: tenantDetails.get("tenant_id"),
    };

    useEffect(() => {
        fetchTenantDetails();
    }, []);


    const fetchTenantDetails = () => {


        setBackDrop(
            <Backdrop
                sx={{color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1}}
                open={true}
                onClick={null}
            >
                <CircularProgress color="inherit"/>
            </Backdrop>
        );
        fetch(ApiDetails + "pegasus/visionary/tenant/app/tenantDetails", {
            method: "POST",
            body: JSON.stringify({
                tenant_id: new Map(
                    Object.entries(JSON.parse(originalText))
                ).get("tenant_id"),
            }),
        })
            .then(async (response) => {
                let data = await response.json();
                if (response.status === 200) {
                    setTenantDetails(new Map(Object.entries(data)));

                    console.log("Status");
                    console.log(tenantDetails.get("status"));

                    setDetailsSet(true);
                    setBackDrop(<></>);
                } else if (response.status === 401) {
                    props.snackBar({
                        text: "Maximum concurrent logins reached",
                        type: "warning",
                    });
                } else if (response.status === 400) {
                    props.snackBar({
                        text: "Invalid Credentials Provided.",
                        type: "error",
                    });
                }
            })
            .catch((err) => {
                console.log(err);
                props.snackBar({
                    text: "Something Went Wrong. Try Again Later",
                    type: "error",
                });
            });
    };

    const processPayment = async (values) => {

        setTenantLoading(true);

        if (values.phone_number.toString().startsWith("0")) {
            values.phone_number = "254" + values.phone_number.toString().substring(1);
        } else if (
            values.phone_number.toString().startsWith("1") ||
            values.phone_number.toString().startsWith("7")
        ) {
            values.phone_number = "254" + values.phone_number.toString();
        }

        if (
            tenantDetails.get("ho_number") === 0 ||
            tenantDetails.get("till_number") === 0 ||
            tenantDetails.get("short_code") === "" ||
            tenantDetails.get("pass_key") === ""
        ) {
            props.snackBar({
                text: "Payment details have not been set for your property",
                type: "error",
            });
            setTenantLoading(false);
            handleClose();
            return;
        }

        let body = {
            BusinessShortCode: tenantDetails.get("ho_number").toString(),
            Password: "",
            Timestamp: "",
            TransactionType: "CustomerBuyGoodsOnline",
            Amount: values.amount,
            PartyA: values.phone_number,
            // PartyB: "6122464",
            PartyB: tenantDetails.get("till_number").toString(),
            PhoneNumber: values.phone_number,
            CallBackURL:
                "https://api.pegasus-pms.co.ke/api/" + "pegasus/visionary/payments/",
            AccountReference: "ITORAMA SOLUTIONS",
            TransactionDesc: "Payment of rent",
            houseNumber: tenantDetails.get("account_number"),
            tenant_id: tenantDetails.get("tenant_id"),
            landlord_id: tenantDetails.get("landlord_id"),
            short_code: tenantDetails.get("short_code"),
            pass_key: tenantDetails.get("pass_key"),
            consumer_key: tenantDetails.get("consumer_key"),
            consumer_secret: tenantDetails.get("consumer_secret"),
        };

        // console.log(tenantDetails);
        fetch(ApiDetails + "pegasus/visionary/mpesa/StkPush", {
            method: "POST",
            body: JSON.stringify(body),
        })
            .then(async (response) => {
                let data = await response.json();
                if (response.status === 200) {
                    setTenantLoading(false);
                    props.snackBar({
                        text: "Kindly wait For mpesa prompt on your phone",
                        type: "success",
                    });
                } else if (response.status === 403) {
                    // console.log(data);
                    setTenantLoading(false);
                    props.snackBar({
                        text: new Map(Object.entries(data)).get("Message"),
                        type: "error",
                    });
                }
                handleClose();
            })
            .catch((err) => {
                console.log(err);
                setTenantLoading(false);
                props.snackBar({
                    text: "Payment Not Successful",
                    type: "error",
                });
            });

        fetchTenantDetails();
    };

    // Helper function to convert month number to name
    function toMonthName(monthNumber) {
        const date = new Date();
        date.setMonth(monthNumber);
        return date.toLocaleString("en-US", {month: "long"});
    }

    // Send vacating notice function
    const sendVacatingNotice = (values) => {
        setTenantLoading(true);

        // Convert editor content to HTML
        const data = draftToHtml(convertToRaw(editorState.getCurrentContent()));

        // Get minimum months before vacating
        let minimumMonthsBeforeVacating = tenantDetails.get("minimum_days_to_vacate");

        // Calculate difference in months
        let dateJoined = new Date(tenantDetails.get("date_created").toString());
        let vacatingDate = new Date(dateToVacate.toJSON());
        let difference =
            vacatingDate.getFullYear() * 12 +
            vacatingDate.getMonth() -
            (dateJoined.getFullYear() * 12 + dateJoined.getMonth());

        // Prepare values
        values = {
            ...values,
            date_to_vacate_house:
                toMonthName(new Date(dateToVacate.toJSON()).getMonth()) +
                " " +
                new Date(dateToVacate.toJSON()).getDate() +
                ", " +
                new Date(dateToVacate.toJSON()).getFullYear(),
            date_notice_given: new Date(),
            reasons_for_vacating: JSON.stringify(
                convertToRaw(editorState.getCurrentContent())
            ),
        };

        // Validate vacating date
        if (difference < minimumMonthsBeforeVacating) {
            // Show warning of not getting deposit back
            setValuesAfterWarning(values);
            handleClose();
            setVacatingWarningModalNotice(
                "Please note that you need to have occupied the premises for at least " +
                minimumMonthsBeforeVacating +
                " months to qualify for refund of deposit.\nIf you " +
                "proceed, your deposit shall not be refunded"
            );
            setWarningModal(true);
            setTenantLoading(false);
            return;
        } else if (
            new Date(dateToVacate.toJSON()).getFullYear() < dateToday.getFullYear()
        ) {
            props.snackBar({
                text: "Invalid date to vacate.",
                type: "error",
            });
            setTenantLoading(false);
            return;
        } else if (
            new Date(dateToVacate.toJSON()).getFullYear() === dateToday.getFullYear() &&
            new Date(dateToVacate.toJSON()).getMonth() < dateToday.getMonth()
        ) {
            props.snackBar({
                text: "Invalid date to vacate.",
                type: "error",
            });
            setTenantLoading(false);
            return;
        } else if (
            new Date(dateToVacate.toJSON()).getDate() < 28 &&
            new Date(dateToVacate.toJSON()).getMonth() === dateToday.getMonth()
        ) {
            setValuesAfterWarning(values);
            handleClose();
            setVacatingWarningModalNotice(
                "Notice to vacate are given one month in advance.\nIf you " +
                "proceed, you risk not being refunded your deposit"
            );
            setWarningModal(true);
            setTenantLoading(false);
            return;
        } else if (
            dateToday.getDate() >= 3 &&
            new Date(dateToVacate.toJSON()).getMonth() === dateToday.getMonth()
        ) {
            setValuesAfterWarning(values);
            handleClose();
            setVacatingWarningModalNotice(
                "Notice to vacate are given before the 3rd of the month.\nIf you " +
                "proceed, you risk not being refunded your deposit"
            );
            setWarningModal(true);
            setTenantLoading(false);
            return;
        } else if (new Date(dateToVacate.toJSON()).getDate() < 28) {
            props.snackBar({
                text: "You can only vacate property at the end of the month",
                type: "error",
            });
            setTenantLoading(false);
            return;
        } else {
            // Simulate API call
            setTimeout(() => {
                props.snackBar({
                    text: "Notice Successfully Uploaded",
                    type: "success",
                });
                setTenantLoading(false);
                handleClose();
                fetchTenantDetails();
            }, 2000);
        }
    };

    // Send vacating notice after warning
    const sendVacatingNoticeAfterWarning = () => {
        // Simulate API call
        setTimeout(() => {
            props.snackBar({
                text: "Notice Successfully Uploaded",
                type: "success",
            });
            setTenantLoading(false);
            handleClose();
            fetchTenantDetails();
        }, 2000);
    };

    // Dialog close handler
    const handleClose = () => {
        setPaymentModal(false);
        setVacatingNoticeModal(false);
        setWarningModal(false);
    };

    // Format amount based on status
    const getFormattedWalletBalance = () => {
        if (tenantDetails.get("status") !== "COMPLETED") {
            return parseInt("0").toLocaleString("en-US", {
                style: "currency",
                currency: "KSH",
            });
        } else {
            return parseInt(
                tenantDetails.get("Wallet")?.toString().replace(",", "") || "0"
            ).toLocaleString("en-US", {
                style: "currency",
                currency: "KSH",
            });
        }
    };

    return (
        <>
            {backDrop}

            {/* Warning Dialog */}
            <Dialog
                open={warningModal}
                TransitionComponent={Transition}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
                PaperProps={{
                    style: {
                        borderRadius: '12px',
                        boxShadow: '0 8px 24px rgba(0,0,0,0.15)'
                    }
                }}
            >
                <DialogTitle
                    style={{
                        color: "#3A5A78",
                        borderBottom: '1px solid #eaeaea',
                        padding: '20px 24px',
                        fontSize: '18px',
                        fontWeight: 600
                    }}
                >
                    Warning
                </DialogTitle>
                <DialogContent sx={{padding: '24px'}}>
                    <DialogContentText id="alert-dialog-slide-description">
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-start",
                                alignItems: "center",
                                gap: "16px"
                            }}
                        >
                            <Warning
                                style={{
                                    fontSize: 40,
                                    color: "#F59E0B",
                                }}
                            />
                            <div style={{fontSize: '15px', lineHeight: '1.5'}}>
                                {vacatingWarningModalNotice}
                            </div>
                        </div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{padding: '16px 24px'}}>
                    <Button
                        onClick={() => {
                            handleClose();
                            sendVacatingNoticeAfterWarning();
                        }}
                        style={{
                            color: "#10B981",
                            fontWeight: 500,
                            textTransform: 'none'
                        }}
                    >
                        Proceed
                    </Button>
                    <Button
                        onClick={handleClose}
                        style={{
                            color: "#EF4444",
                            fontWeight: 500,
                            textTransform: 'none'
                        }}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

            {detailsSet && (
                <>
                    {/* Payment Dialog */}
                    <Dialog
                        open={paymentModal}
                        TransitionComponent={Transition}
                        keepMounted
                        aria-describedby="payment-dialog-description"
                        PaperProps={{
                            style: {
                                borderRadius: '12px',
                                boxShadow: '0 8px 24px rgba(0,0,0,0.15)'
                            }
                        }}
                    >
                        <DialogTitle
                            style={{
                                color: "#3A5A78",
                                borderBottom: '1px solid #eaeaea',
                                padding: '20px 24px',
                                fontSize: '18px',
                                fontWeight: 600
                            }}
                        >
                            Make Payment
                        </DialogTitle>
                        <DialogContent sx={{padding: '24px'}}>
                            <DialogContentText id="payment-dialog-description">
                                <Formik
                                    initialValues={initialPaymentValues}
                                    validationSchema={basicSchema}
                                    onSubmit={processPayment}
                                >
                                    {(props) => (
                                        <Form noValidate>
                                            <p style={{marginBottom: '16px', color: '#4B5563'}}>
                                                Enter number to be prompted to make payment
                                            </p>
                                            <Field
                                                as={TextField}
                                                name="phone_number"
                                                label="Phone Number"
                                                error={
                                                    props.errors.phone_number &&
                                                    props.touched.phone_number
                                                }
                                                helperText={
                                                    <ErrorMessage className="error" name="phone_number"/>
                                                }
                                                required
                                                variant="outlined"
                                                style={{marginTop: "16px", width: "100%"}}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: {color: '#3A5A78'}
                                                }}
                                            />
                                            <Field
                                                as={TextField}
                                                name="amount"
                                                label="Amount"
                                                type="number"
                                                required
                                                variant="outlined"
                                                error={props.errors.amount && props.touched.amount}
                                                helperText={
                                                    <ErrorMessage className="error" name="amount"/>
                                                }
                                                style={{marginTop: "16px", width: "100%"}}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: {color: '#3A5A78'}
                                                }}
                                            />

                                            <div
                                                style={{
                                                    width: "100%",
                                                    display: "flex",
                                                    justifyContent: "flex-end",
                                                    marginTop: "24px",
                                                    gap: "12px"
                                                }}
                                            >
                                                <Button
                                                    onClick={handleClose}
                                                    style={{
                                                        color: "#EF4444",
                                                        fontWeight: 500,
                                                        textTransform: 'none'
                                                    }}
                                                >
                                                    Cancel
                                                </Button>
                                                <LoadingButton
                                                    type="submit"
                                                    size="medium"
                                                    loading={tenantLoading}
                                                    startIcon={<Send/>}
                                                    style={{
                                                        color: "white",
                                                        backgroundColor: "#3A5A78",
                                                        textTransform: 'none',
                                                        padding: '8px 16px',
                                                        borderRadius: '6px'
                                                    }}
                                                    loadingPosition="start"
                                                >
                                                    Submit
                                                </LoadingButton>
                                            </div>
                                        </Form>
                                    )}
                                </Formik>
                            </DialogContentText>
                        </DialogContent>
                    </Dialog>

                    {/* Vacating Notice Dialog */}
                    <Dialog
                        maxWidth="md"
                        open={vacatingNoticeModal}
                        TransitionComponent={Transition}
                        keepMounted
                        aria-describedby="vacating-notice-dialog-description"
                        PaperProps={{
                            style: {
                                borderRadius: '12px',
                                boxShadow: '0 8px 24px rgba(0,0,0,0.15)'
                            }
                        }}
                    >
                        <DialogTitle
                            style={{
                                color: "#3A5A78",
                                borderBottom: '1px solid #eaeaea',
                                padding: '20px 24px',
                                fontSize: '18px',
                                fontWeight: 600,
                                textAlign: 'center'
                            }}
                        >
                            Vacating Notice
                        </DialogTitle>
                        <DialogContent
                            style={{
                                padding: '24px',
                            }}
                        >
                            <Formik
                                initialValues={initialValues2}
                                validationSchema={dateSchema}
                                onSubmit={sendVacatingNotice}
                            >
                                {(props) => (
                                    <Form noValidate>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                gap: "16px",
                                                flexWrap: "wrap"
                                            }}
                                        >
                                            <Field
                                                as={TextField}
                                                name="first_name"
                                                label="First Name"
                                                variant="outlined"
                                                error={
                                                    props.errors.first_name && props.touched.first_name
                                                }
                                                helperText={
                                                    <ErrorMessage className="error" name="first_name"/>
                                                }
                                                required
                                                disabled={true}
                                                style={{marginTop: "16px", width: "calc(33.33% - 11px)"}}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: {color: '#3A5A78'}
                                                }}
                                            />
                                            <Field
                                                as={TextField}
                                                name="last_name"
                                                label="Last Name"
                                                error={
                                                    props.errors.last_name && props.touched.last_name
                                                }
                                                helperText={
                                                    <ErrorMessage className="error" name="last_name"/>
                                                }
                                                required
                                                variant="outlined"
                                                disabled={true}
                                                style={{marginTop: "16px", width: "calc(33.33% - 11px)"}}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: {color: '#3A5A78'}
                                                }}
                                            />
                                            <Field
                                                as={TextField}
                                                name="national_id"
                                                label="National ID"
                                                type="number"
                                                required
                                                variant="outlined"
                                                disabled={true}
                                                style={{marginTop: "16px", width: "calc(33.33% - 11px)"}}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: {color: '#3A5A78'}
                                                }}
                                            />
                                        </div>

                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                gap: "16px"
                                            }}
                                        >
                                            <Field
                                                as={TextField}
                                                name="phone_number"
                                                label="Phone Number"
                                                error={
                                                    props.errors.phone_number &&
                                                    props.touched.phone_number
                                                }
                                                className={
                                                    props.errors.phone_number &&
                                                    props.touched.phone_number
                                                        ? "input-error"
                                                        : ""
                                                }
                                                helperText={
                                                    <ErrorMessage className="error" name="phone_number"/>
                                                }
                                                required
                                                variant="outlined"
                                                style={{marginTop: "16px", width: "calc(50% - 8px)"}}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: {color: '#3A5A78'}
                                                }}
                                            />
                                            <Field
                                                as={TextField}
                                                name="unit"
                                                label="House Number"
                                                error={props.errors.unit && props.touched.unit}
                                                helperText={
                                                    <ErrorMessage className="error" name="unit"/>
                                                }
                                                required
                                                disabled={true}
                                                variant="outlined"
                                                style={{marginTop: "16px", width: "calc(50% - 8px)"}}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: {color: '#3A5A78'}
                                                }}
                                            />
                                        </div>

                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                gap: "16px"
                                            }}
                                        >
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DesktopDatePicker
                                                    disabled={true}
                                                    value={dateToday}
                                                    onChange={() => {
                                                    }}
                                                    label="Date Today"
                                                    inputFormat="MM/DD/YYYY"
                                                    renderInput={(params) => (
                                                        <TextField
                                                            name="date_notice_given"
                                                            error={
                                                                props.errors.date_notice_given &&
                                                                props.touched.date_notice_given
                                                            }
                                                            helperText={
                                                                <ErrorMessage
                                                                    className="error"
                                                                    name="date_notice_given"
                                                                />
                                                            }
                                                            style={{marginTop: "16px", width: "calc(50% - 8px)"}}
                                                            {...params}
                                                            InputLabelProps={{
                                                                style: {color: '#3A5A78'}
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </LocalizationProvider>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DesktopDatePicker
                                                    label="Date To Vacate"
                                                    inputFormat="MM/DD/YYYY"
                                                    value={dateToVacate}
                                                    onChange={(newValue) => setDateToVacate(newValue)}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            name="date_to_vacate_House"
                                                            error={
                                                                props.errors.date_to_vacate_House &&
                                                                props.touched.date_to_vacate_House
                                                            }
                                                            helperText={
                                                                <ErrorMessage
                                                                    className="error"
                                                                    name="date_notice_given"
                                                                />
                                                            }
                                                            style={{marginTop: "16px", width: "calc(50% - 8px)"}}
                                                            {...params}
                                                            InputLabelProps={{
                                                                style: {color: '#3A5A78'}
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </LocalizationProvider>
                                        </div>

                                        <div
                                            style={{
                                                marginTop: "24px",
                                            }}
                                        >
                                            <label style={{
                                                display: 'block',
                                                marginBottom: '8px',
                                                color: '#3A5A78',
                                                fontWeight: 500
                                            }}>
                                                Reason for Vacating
                                            </label>
                                            <RichTextEditor
                                                richTextValue={editorState}
                                                change={(value) => {
                                                    setEditorState(value);
                                                }}
                                            />
                                        </div>

                                        <div
                                            style={{
                                                width: "100%",
                                                display: "flex",
                                                justifyContent: "flex-end",
                                                marginTop: "24px",
                                                gap: "12px"
                                            }}
                                        >
                                            <Button
                                                onClick={handleClose}
                                                style={{
                                                    color: "#EF4444",
                                                    fontWeight: 500,
                                                    textTransform: 'none'
                                                }}
                                            >
                                                Cancel
                                            </Button>
                                            <LoadingButton
                                                type="submit"
                                                size="medium"
                                                loading={tenantLoading}
                                                startIcon={<Send/>}
                                                style={{
                                                    color: "white",
                                                    backgroundColor: "#3A5A78",
                                                    textTransform: 'none',
                                                    padding: '8px 16px',
                                                    borderRadius: '6px'
                                                }}
                                                loadingPosition="start"
                                            >
                                                Submit
                                            </LoadingButton>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </DialogContent>
                    </Dialog>
                </>
            )}

            {/* Main Dashboard Cards */}
            <div style={{
                fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif"
            }}>
                {/* Top Row Cards */}
                <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '24px',
                    marginBottom: '24px'
                }}>
                    {/* Wallet Balance Card */}
                    <div style={{
                        flex: '1',
                        // minWidth: '280px',
                        backgroundColor: '#F0FDF4',
                        borderRadius: '12px',
                        padding: '24px',
                        boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                        border: '1px solid #D1FAE5',
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '16px'
                        }}>
                            <h3 style={{
                                margin: 0,
                                color: '#065F46',
                                fontSize: '16px',
                                fontWeight: 600
                            }}>
                                Wallet Balance
                            </h3>
                            <AccountBalanceWallet style={{color: '#059669'}}/>
                        </div>

                        <HtmlTooltip title="Account Balance">
                            <p style={{
                                fontSize: '24px',
                                fontWeight: 700,
                                margin: '0 0 16px 0',
                                color: '#065F46'
                            }}>
                                {getFormattedWalletBalance()}
                            </p>
                        </HtmlTooltip>

                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            padding: '6px 0',
                            color: '#059669',
                            fontWeight: 500,
                            fontSize: '14px'
                        }} onClick={() => {
                            setPaymentModal(true);
                        }}>
                            <span>Deposit</span>
                            <Payment style={{marginLeft: '8px', fontSize: '18px'}}/>
                        </div>
                    </div>

                    {/* Property Card */}
                    <div style={{
                        flex: '1',
                        // minWidth: '280px',
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        padding: '24px',
                        boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                        border: '1px solid #E5E7EB',
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '16px'
                        }}>
                            <h3 style={{
                                margin: 0,
                                color: '#3A5A78',
                                fontSize: '16px',
                                fontWeight: 600
                            }}>
                                Property
                            </h3>
                            <Apartment style={{color: '#3B82F6'}}/>
                        </div>

                        <p style={{
                            fontSize: '24px',
                            fontWeight: 700,
                            margin: '0 0 16px 0',
                            color: '#3A5A78'
                        }}>
                            {tenantDetails.get("property_name")}
                        </p>

                        <div style={{
                            fontSize: '14px',
                            color: '#6B7280'
                        }}>
                            Unit {tenantDetails.get("house_number")}
                        </div>
                    </div>

                    {/* Rent Agreed Card */}
                    <div style={{
                        flex: '1',
                        // minWidth: '280px',
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        padding: '24px',
                        boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                        border: '1px solid #E5E7EB',
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '16px'
                        }}>
                            <h3 style={{
                                margin: 0,
                                color: '#3A5A78',
                                fontSize: '16px',
                                fontWeight: 600
                            }}>
                                Rent Agreed
                            </h3>
                        </div>

                        <p style={{
                            fontSize: '24px',
                            fontWeight: 700,
                            margin: '0 0 16px 0',
                            color: '#3A5A78'
                        }}>
                            {tenantDetails.get("rent")?.toLocaleString("en-US", {
                                style: "currency",
                                currency: "KSH",
                            })}
                        </p>

                        <div style={{
                            fontSize: '14px',
                            color: '#6B7280'
                        }}>
                            Rent Is Due By 5<sup>th</sup>
                        </div>
                    </div>
                </div>

                {/* Bottom Row Cards */}
                <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '24px'
                }}>
                    {/* Pending Bill Card */}
                    {tenantDetails.get("status") !== "COMPLETED" ? (
                        <motion.div
                            animate={{scale: [0.98, 1, 0.98]}}
                            transition={{duration: 3, repeat: Infinity}}
                            style={{
                                flex: '1',
                                // minWidth: '280px',
                                backgroundColor: '#FEF2F2',
                                borderRadius: '12px',
                                padding: '24px',
                                boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                                border: '1px solid #FEE2E2',
                                display: 'flex',
                                flexDirection: 'column'
                            }}
                        >
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '16px'
                            }}>
                                <h3 style={{
                                    margin: 0,
                                    color: '#991B1B',
                                    fontSize: '16px',
                                    fontWeight: 600
                                }}>
                                    Pending Bill
                                </h3>
                            </div>

                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                flexDirection:'column',
                                alignItems: 'center',
                                marginBottom: '16px'
                            }}>
                                <p style={{
                                    fontSize: '24px',
                                    fontWeight: 700,
                                    margin: 0,
                                    color: '#991B1B'
                                }}>
                                    {parseInt(
                                        tenantDetails.get("Wallet")?.toString().replace(",", "") || "0"
                                    ).toLocaleString("en-US", {
                                        style: "currency",
                                        currency: "KSH",
                                    })}
                                </p>

                                <Button
                                    style={{
                                        background: '#EF4444',
                                        color: 'white',
                                        textTransform: 'none',
                                        padding: '8px 16px',
                                        borderRadius: '6px',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                        fontWeight: 500
                                    }}
                                    onClick={() => {
                                        setPaymentModal(true);
                                    }}
                                >
                                    Pay Now
                                    <Payment
                                        style={{
                                            marginLeft: '6px',
                                            fontSize: '20px'
                                        }}
                                    />
                                </Button>
                            </div>

                            <div style={{
                                fontSize: '14px',
                                color: '#B91C1C'
                            }}>
                                Pay On Time To Avoid Penalties
                            </div>
                        </motion.div>
                    ) : (
                        <div style={{
                            flex: '1',
                            // minWidth: '280px',
                            backgroundColor: '#F0FDF4',
                            borderRadius: '12px',
                            padding: '24px',
                            boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                            border: '1px solid #D1FAE5',
                            display: 'flex',
                            flexDirection: 'column'
                        }}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '16px'
                            }}>
                                <h3 style={{
                                    margin: 0,
                                    color: '#065F46',
                                    fontSize: '16px',
                                    fontWeight: 600
                                }}>
                                    Pending Bill
                                </h3>
                            </div>

                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '16px'
                            }}>
                                <p style={{
                                    fontSize: '24px',
                                    fontWeight: 700,
                                    margin: 0,
                                    color: '#065F46'
                                }}>
                                    {parseInt(
                                        "0".toString().replace(",", "") || "0"
                                    ).toLocaleString("en-US", {
                                        style: "currency",
                                        currency: "KSH",
                                    })}
                                </p>

                                <Button
                                    style={{
                                        background: '#10B981',
                                        color: 'white',
                                        textTransform: 'none',
                                        padding: '8px 16px',
                                        borderRadius: '6px',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                        fontWeight: 500
                                    }}
                                    onClick={() => {
                                        setPaymentModal(true);
                                    }}
                                >
                                    Pay Now
                                    <Payment
                                        style={{
                                            marginLeft: '6px',
                                            fontSize: '20px'
                                        }}
                                    />
                                </Button>
                            </div>

                            <div style={{
                                fontSize: '14px',
                                color: '#059669'
                            }}>
                                All Bills Cleared
                            </div>
                        </div>
                    )}

                    {/* Notice Card */}
                    {tenantDetails.get("state") === "NOTICE" ? (
                        <motion.div
                            animate={{scale: [0.98, 1, 0.98]}}
                            transition={{duration: 3, repeat: Infinity}}
                            style={{
                                flex: '1',
                                // minWidth: '280px',
                                backgroundColor: '#EFF6FF',
                                borderRadius: '12px',
                                padding: '24px',
                                boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                                border: '1px solid #DBEAFE',
                                display: 'flex',
                                flexDirection: 'column'
                            }}
                        >
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '16px'
                            }}>
                                <h3 style={{
                                    margin: 0,
                                    color: '#1E40AF',
                                    fontSize: '16px',
                                    fontWeight: 600
                                }}>
                                    Available Notice
                                </h3>
                                <Assignment style={{color: '#3B82F6'}}/>
                            </div>

                            <p style={{
                                fontSize: '16px',
                                fontWeight: 500,
                                margin: '0 0 16px 0',
                                color: '#1E40AF'
                            }}>
                                You requested to vacate on:{" "}
                                <span style={{fontWeight: 700}}>
                  {new Map(
                      Object.entries(tenantDetails.get("notice") || {})
                  ).get("date_to_vacate_house")}
                </span>
                            </p>

                            <div style={{
                                fontSize: '14px',
                                color: '#3B82F6'
                            }}>
                                Date notice given:{" "}
                                {new Map(Object.entries(tenantDetails.get("notice") || {})).get(
                                    "date_created"
                                )}
                            </div>
                        </motion.div>
                    ) : (
                        <div style={{
                            flex: '1',
                            // minWidth: '280px',
                            backgroundColor: 'white',
                            borderRadius: '12px',
                            padding: '24px',
                            boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                            border: '1px solid #E5E7EB',
                            display: 'flex',
                            flexDirection: 'column'
                        }}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '16px'
                            }}>
                                <h3 style={{
                                    margin: 0,
                                    color: '#3A5A78',
                                    fontSize: '16px',
                                    fontWeight: 600
                                }}>
                                    Notice
                                </h3>
                                <Assignment style={{color: '#3B82F6'}}/>
                            </div>

                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '16px'
                            }}>
                                <p style={{
                                    fontSize: '16px',
                                    fontWeight: 500,
                                    margin: 0,
                                    color: '#3A5A78'
                                }}>
                                    Vacating Notice
                                </p>

                                <Button
                                    style={{
                                        background: '#3B82F6',
                                        color: 'white',
                                        textTransform: 'none',
                                        padding: '8px 16px',
                                        borderRadius: '6px',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                        fontWeight: 500
                                    }}
                                    onClick={() => {
                                        setVacatingNoticeModal(true);
                                    }}
                                >
                                    Fill Form
                                    <Assignment
                                        style={{
                                            marginLeft: '6px',
                                            fontSize: '20px'
                                        }}
                                    />
                                </Button>
                            </div>

                            <div style={{
                                fontSize: '14px',
                                color: '#6B7280'
                            }}>
                                Ts & Cs Apply
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}